import { CAMPAIGN_STATUSES_RUNNING_OR_RUNNED, ICampaign } from "campaign/model"
import { campaignRPO } from "campaign/repository"

export const searchCampaignsByName = (filter: string, onlyRanCampaigns?: boolean): Promise<ICampaign[]> =>
  campaignRPO.getCampaigns(
    { page: 0, pageSize: 1000 },
    {
      name: filter,
      creationDate: { date: null, labelKey: "" },
      startEndPeriod: { startDate: null, endDate: null },
      advertiserIds: [],
      orderIds: [],
      statuses: onlyRanCampaigns ? CAMPAIGN_STATUSES_RUNNING_OR_RUNNED.slice() : [],
      isForecast: false
    }
  )
